import { PriceChangeSubmissionStatus } from "@/graphql/codegen/graphql"
import type { PriceChangeHistorySearchParams } from "@/screens/Pricing/types/searchParams"
import type { Option } from "@/types/form-fields"

export const PRICE_CHANGE_PAGE_SIZE = 20

export const BULK_UPDATE_APPLYING_HIDE_DELAY_MS = 1_000

export const AS400_PRICE_MAX = 999.9999 // AS400 constraint

export enum PricingNumericTypeValues {
  Percent = "%",
  Dollar = "$",
}

export enum PriceChangeTableVariant {
  SubmitPriceChange = "SubmitPriceChange",
  ReviewSubmission = "ReviewSubmission",
  RevertSubmission = "RevertSubmission",
}

export enum RecipientType {
  Customer = "Customer",
  Contact = "Contact",
}

export enum SubmitConfirmation {
  LapsedDate = "lapsedDate",
  DefaultedDate = "defaultedDate",
}

export enum PricingDialogs {
  SubmitPriceChange = "submitPriceChange",
  SendSellingPrice = "sendSellingPrice",
  ReSendSellingPrice = "reSendSellingPrice",
  ReSendToIndividual = "reSendToIndividual",
  AddSpecialPrice = "addSpecialPrice",
  AddCostPackage = "addCostPackage",
  DenyPriceChangeConfirmationDialog = "denyPriceChangeConfirmationDialog",
  RemovePricingFilterChipConfirmation = "removePricingFilterChipConfirmation",
  ApplyPricingFiltersConfirmation = "applyPricingFiltersConfirmation",
  ClearAllFiltersConfirmation = "clearAllFiltersConfirmation",
  ClearBulkUpdateConfirmation = "clearBulkUpdateConfirmation",
  AutoResetEffectiveDateConfirmation = "autoResetEffectiveDateConfirmation",
  DefaultedEffectiveDateConfirmation = "defaultedEffectiveDateConfirmation",
  RemoveSubmissionProductConfirmation = "removeSubmissionProductConfirmation",
}

export const SUBMIT_CONFIRMATION_TO_DIALOG: Record<SubmitConfirmation, PricingDialogs> = {
  [SubmitConfirmation.LapsedDate]: PricingDialogs.AutoResetEffectiveDateConfirmation,
  [SubmitConfirmation.DefaultedDate]: PricingDialogs.DefaultedEffectiveDateConfirmation,
}

export const PRICE_CHANGE_SUBMISSION_STATUS_LABELS: Record<PriceChangeSubmissionStatus, string> = {
  [PriceChangeSubmissionStatus.Submitted]: "Submitted",
  [PriceChangeSubmissionStatus.Approved]: "Approved",
  [PriceChangeSubmissionStatus.Denied]: "Denied",
  [PriceChangeSubmissionStatus.Reverted]: "Reverted",
  [PriceChangeSubmissionStatus.Draft]: "Draft",
} as const

export const SELLING_PRICE_STATUS_OPTIONS: Option<PriceChangeSubmissionStatus>[] = [
  PriceChangeSubmissionStatus.Submitted,
  PriceChangeSubmissionStatus.Denied,
  PriceChangeSubmissionStatus.Approved,
].map((status) => ({
  value: status,
  label: PRICE_CHANGE_SUBMISSION_STATUS_LABELS[status],
}))

export const SELLING_PRICE_FILTER_KEYS: (keyof PriceChangeHistorySearchParams)[] = [
  "assignedToIds",
  "status",
  "dateFrom",
  "dateTo",
  "changeType",
]

export const PURCHASING_COST_FILTER_KEYS: (keyof PriceChangeHistorySearchParams)[] = [
  "dateFrom",
  "dateTo",
  "changeType",
]
